const APP_VERSION = '1.10.20';

export default APP_VERSION;
